import { axiosApi } from '../globals';

export namespace templates {
  export const getAll = () => {
    return axiosApi.run('get', '/template/list');
  };

  export const get = (id: string) => {
    return axiosApi.run('get', `/template/Single?id=${id}`);
  };
}
